module.exports = ".form-group select {\n  -webkit-appearance: menulist; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tags/shared/tag-form/tag-form.component.scss
// module id = ./src/app/tags/shared/tag-form/tag-form.component.scss
// module chunks = main